import React from "react";
import PlasticSealManagementTable from "./PlasticSealManagementTable";

const PlasticSealManagement = () => {

  return <div>{<PlasticSealManagementTable />}</div>;
};

export default PlasticSealManagement;
